import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { setState } from 'react';
import { Form, Field, withFormik } from 'formik';
import * as yup from 'yup';
import { FaSearch } from 'react-icons/fa'; // Form Debugger
// import { Debug } from "./Debug";

import { Row, Col, Button } from 'react-bootstrap'; // Global Element

import { FormInputAhead } from './elements'; // Validation schema

import { required } from './util/validation'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
var formikEnhancer = withFormik({
  validateOnChange: false,
  validateOnBlur: false,
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      searchQuery: props.searchQuery,
      results: props.results
    };
  },
  validationSchema: yup.object().shape({
    searchQuery: required('Search is required') // TODO: Change to a constant

  }),
  handleSubmit: function handleSubmit(values, _ref) {
    var props = _ref.props,
        setSubmitting = _ref.setSubmitting;
    setSubmitting(false); //console.log('Search bar props: ', props);
  },
  displayName: "SearchBarForm" // helps with React DevTools

});

var SearchBarForm = function SearchBarForm(props) {
  var values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset,
      className = props.className,
      _props$results = props.results,
      results = _props$results === void 0 ? [] : _props$results,
      changeHandler = props.changeHandler;

  var gaSearch = function gaSearch() {
    var data = {
      gtm: {
        uniqueEventId: '28',
        elementId: "search-query"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var inputChangeHandler = function inputChangeHandler(query) {
    props.setFieldValue('searchQuery', query);
    gaSearch();
    return changeHandler(query);
  };

  var decodeHTML = function decodeHTML(html) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  var mappedResults = results.map(function (result) {
    return _objectSpread(_objectSpread({}, result), {}, {
      Title: decodeHTML(result.Title).replace(/(<([^>]+)>)/ig, "")
    });
  });
  var isActiveClass = className;

  var searchBarClick = function searchBarClick() {
    var data = {
      gtm: {
        uniqueEventId: '27',
        elementId: "search-query-button"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  return /*#__PURE__*/React.createElement(Form, {
    className: isActiveClass,
    onSubmit: function onSubmit(e) {
      e.persist();
      e.preventDefault();
      return window.location.href = "/search?query=".concat(e.target[0].value);
    }
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    type: "text",
    name: "Search",
    label: props.placeholder,
    className: isActiveClass,
    changeHandler: inputChangeHandler,
    component: FormInputAhead,
    autocomplete: "off",
    id: "search-query",
    results: mappedResults
  }), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    id: "search-query-button",
    disabled: isSubmitting,
    className: "cb-button-unstyled cb-form__search-button",
    onClick: function onClick() {
      return searchBarClick();
    }
  }, /*#__PURE__*/React.createElement(FaSearch, null)))));
};

var SearchQuery = formikEnhancer(SearchBarForm);
export default formikEnhancer(SearchBarForm);